import { render, staticRenderFns } from "./TicketPanel.vue?vue&type=template&id=3a8d8dea&scoped=true&"
import script from "./TicketPanel.vue?vue&type=script&lang=js&"
export * from "./TicketPanel.vue?vue&type=script&lang=js&"
import style0 from "./TicketPanel.vue?vue&type=style&index=0&id=3a8d8dea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d8dea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
